var map = {
	"./assets/adverts/isomatch_eye.jpg": "f47c",
	"./assets/adverts/isomatch_grip.jpg": "2453",
	"./assets/adverts/isomatch_inline.jpg": "0250",
	"./assets/adverts/kverneland_exacta_tlx_geospread.jpg": "840f",
	"./assets/adverts/kverneland_ixdrive_s6.jpg": "f218",
	"./assets/adverts/kverneland_ixter_b.jpg": "0de4",
	"./assets/adverts/kverneland_ixtrack_t4.jpg": "dc07",
	"./assets/adverts/kverneland_optima_tfprofi.jpg": "a7d3",
	"./assets/adverts/kverneland_optima_v.jpg": "e8bf",
	"./assets/adverts/kverneland_u_drill.jpg": "9390",
	"./assets/adverts/vicon_rotaflow_ro_edw_geospread.jpg": "3173",
	"./assets/adverts/vicon_rotaflow_ro_m_geospread.jpg": "acac",
	"./assets/countries/HU.png": "43d7",
	"./assets/countries/IEN.png": "2959",
	"./assets/countries/NL.png": "6c95",
	"./assets/countries/PL.png": "490b",
	"./assets/countries/RU.png": "c70c",
	"./assets/countries/RU.webp": "184f",
	"./assets/countries/de.png": "f466",
	"./assets/countries/es.png": "74c3",
	"./assets/countries/fr.png": "efb3",
	"./assets/countries/gb.png": "1075",
	"./assets/countries/it.png": "9342",
	"./assets/css/styles.css": "034b",
	"./assets/images/KVG_logo_footer.png": "d427",
	"./assets/images/KVG_logo_header.jpg": "6db4",
	"./assets/images/KVG_logo_header.svg": "47f3",
	"./assets/images/background.jpg": "b13e",
	"./assets/images/chevron_down.png": "a9ff",
	"./assets/images/chevron_up.png": "4dab",
	"./assets/images/field-sizes/field_1.svg": "613b",
	"./assets/images/field-sizes/field_1_highlighted.svg": "dad6",
	"./assets/images/field-sizes/field_2.svg": "e051",
	"./assets/images/field-sizes/field_2_highlighted.svg": "6ffa",
	"./assets/images/field-sizes/field_3.svg": "7479",
	"./assets/images/field-sizes/field_3_highlighted.svg": "3166",
	"./assets/images/field-sizes/field_4.svg": "378d",
	"./assets/images/field-sizes/field_4_highlighted.svg": "f6ca",
	"./assets/images/iMfarming.png": "4820",
	"./assets/images/logos_footer.svg": "ff12",
	"./assets/images/seeder.png": "ceea",
	"./assets/images/spinner.svg": "6e43",
	"./assets/images/sprayer.png": "53b3",
	"./assets/images/spreader.png": "dcae",
	"./assets/images/vicon_logo.png": "323e",
	"./assets/socials/facebook_logo.png": "0178",
	"./assets/socials/instagram_logo.png": "3c26",
	"./assets/socials/linkedin_logo.png": "08f1",
	"./assets/socials/twitter_logo.png": "7cfe",
	"./assets/socials/youtube_logo.png": "0067",
	"./assets/videos/home_background.mp4": "d432",
	"./assets/videos/home_background.webm": "d19d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";